module.exports = __webpack_public_path__ + "static/social-preview-cb8bc14a1820d0f367288d9be33d052e.png";